module.exports = __webpack_public_path__ + "img/gato.ae1aee67.svg";